import React, { memo } from 'react'
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Box
} from '@material-ui/core'
import { Bot, Network } from 'lucide-react'

import { ButtonSecondary } from '../ButtonSecondary'
import { QueueDepartmentSelect } from '../QueueDepartmentSelect'
import iconWhatsApp from '../../assets/whatsapp.svg'
import { useStyles } from './style'

const BotConnectionsModal = ({
  open,
  onClose,
  connections,
  onSelect,
  selectedBots,
  title = 'Conexões do Tipo Bot',
  emptyMessage = 'Nenhuma conexão encontrada.',
  connectionsAsSelect = false,
  onConnectionsChange,
  showDepartmentSelect = false,
  departments = [],
  selectedDepartments = [],
  onDepartmentChange
}) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      scroll="paper"
    >
      <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>
      <DialogContent dividers className={classes.dialogContent}>

        {connectionsAsSelect ? (
          <Box marginBottom={2}>
            <QueueDepartmentSelect
              label="Conexões"
              placeholder="Selecione as conexões"
              includeAllOption={false}
              filterByIsBot={null}
              filterNotificationAct={false}
              isMulti={true}
              value={selectedBots}
              customOptions={connections}
              onChange={onConnectionsChange}
            />
          </Box>
        ) : (
          <List className={classes.botList}>
            {connections.length > 0 ? (
              connections.map(conn => (
                <ListItem
                  key={conn.id}
                  className={classes.botListItem}
                  onClick={() => onSelect(conn)}
                  button
                >
                  <Checkbox
                    checked={selectedBots.some(bot => bot.id === conn.id)}
                    className={classes.checkbox}
                    tabIndex={-1}
                    disableRipple
                  />
                  <Network size={20} className={classes.botIcon} />
                  <img
                    src={iconWhatsApp}
                    alt="WhatsApp"
                    style={{ width: 16, height: 16 }}
                  />
                  <ListItemText primary={conn.name} className={classes.botName} />
                </ListItem>
              ))
            ) : (
              <ListItem>
                <ListItemText primary={emptyMessage} />
              </ListItem>
            )}
          </List>
        )}
        {showDepartmentSelect && (
          <Box marginBottom={2}>
            <QueueDepartmentSelect
              label="Departamentos"
              placeholder="Selecione os departamentos"
              includeAllOption={true}
              showBots={false}
              filterByIsBot={true}
              filterNotificationAct={true}
              isMulti={true}
              value={selectedDepartments}
              customOptions={departments}
              onChange={onDepartmentChange}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <ButtonSecondary onClick={onClose} label="Fechar" />
      </DialogActions>
    </Dialog>
  )
}

// O memo evita re-renders desnecessários quando o pai atualiza!
export default memo(BotConnectionsModal)
